import { Card, CardBody } from '@vnetwork/ui/primitives';
import { InfoGrid } from '@/pages/account/components/InfoGrid';
import type { EmployeeRecord } from '@/api/employees';

interface Props { emp: EmployeeRecord }

/**
 * Finance tab — bank account details, insurance numbers, tax code, and medical
 * registration. Matches the legacy Update/TabComponents/Finance panel.
 * Sensitive field values are displayed as-is; the UI shows field labels only
 * (no masking — HR-admin console, not a public-facing surface).
 */
export function EmployeeTabFinance({ emp }: Props) {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Bank account
          </p>
          <InfoGrid
            items={[
              { label: 'Bank name', value: emp.employee_bank_name },
              { label: 'Branch', value: emp.employee_bank_branch },
              { label: 'Account number', value: emp.employee_bank_number },
            ]}
          />
        </CardBody>
      </Card>

      <Card flat>
        <CardBody>
          <p style={{
            margin: '0 0 var(--vn-space-3)',
            fontSize: 'var(--vn-font-size-sm)',
            fontWeight: 'var(--vn-font-weight-semibold)',
            color: 'var(--vn-fg-default)',
          }}>
            Insurance &amp; tax
          </p>
          <InfoGrid
            items={[
              { label: 'Personal tax code', value: emp.employee_personal_tax_code },
              { label: 'Health insurance', value: emp.employee_health_insurance },
              { label: 'Social insurance', value: emp.employee_social_insurance },
              { label: 'Medical registration place', value: emp.employee_medical_registration_place, full: true },
            ]}
          />
        </CardBody>
      </Card>
    </div>
  );
}
